import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Download, FileText, FileSpreadsheet, Clock } from 'lucide-react';
import ExportConfirmationModal from '../../components/compliance/ExportConfirmationModal';

const ExportPage = () => {
  const { projectId } = useParams();
  const [showExportModal, setShowExportModal] = useState(false);

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Export</h1>
        <p className="text-sm text-gray-500 mt-1">
          Export compliance reports, evidence packages, and audit-ready documentation.
        </p>
      </div>

      <div className="space-y-4">
        {[
          {
            title: 'Compliance Report (PDF)',
            description: 'Full compliance report with control status, evidence summary, and gap analysis.',
            icon: FileText,
            iconBg: 'bg-red-100',
            iconColor: 'text-red-600',
            comingSoon: true,
          },
          {
            title: 'Evidence Package (ZIP)',
            description: 'Bundled evidence files, screenshots, and configuration snapshots for auditor review.',
            icon: Download,
            iconBg: 'bg-teal-100',
            iconColor: 'text-teal-600',
            comingSoon: false,
            onClick: () => setShowExportModal(true),
          },
          {
            title: 'Controls Matrix (CSV)',
            description: 'Spreadsheet of all controls with status, owner, and evidence references.',
            icon: FileSpreadsheet,
            iconBg: 'bg-green-100',
            iconColor: 'text-green-600',
            comingSoon: true,
          },
        ].map((item) => {
          const Icon = item.icon;
          return (
            <div
              key={item.title}
              className="bg-white rounded-lg border border-gray-200 p-6 flex items-start gap-4"
            >
              <div className={`w-10 h-10 ${item.iconBg} rounded-lg flex items-center justify-center flex-shrink-0`}>
                <Icon className={`w-5 h-5 ${item.iconColor}`} />
              </div>
              <div className="flex-1">
                <h3 className="text-base font-semibold text-gray-900">{item.title}</h3>
                <p className="text-sm text-gray-600 mt-1">{item.description}</p>
              </div>
              {item.comingSoon ? (
                <div className="flex items-center gap-2 text-sm text-gray-400">
                  <Clock className="w-4 h-4" />
                  Coming soon
                </div>
              ) : (
                <button
                  onClick={item.onClick}
                  className="flex items-center gap-2 px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded-lg text-sm font-medium transition-colors"
                >
                  <Download className="w-4 h-4" />
                  Export
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* Export Confirmation Modal */}
      {showExportModal && (
        <ExportConfirmationModal
          projectId={projectId}
          onClose={() => setShowExportModal(false)}
        />
      )}
    </div>
  );
};

export default ExportPage;
